<template>
  <div class="wrapper">
    <div class="container">
      <div class="title">
        <div class="title_info">
          <div class="name">
            <span>欢迎您：{{info.name}}</span>
          </div>
          <p class="tip2">
            <span>所属机构：{{info.orgName}}</span>
            <span class="tip2_line"></span>
            <span>处理组</span>
          </p>
        </div>
        <div class="images">
          <img src="../../../../assets/refund/ic_tuihuo_bg@2x.png" alt />
        </div>
      </div>
      <div class="check_list">
        <div class="item">
          <p class="t_text">退货处置工作台</p>
          <div class="box">
            <div
              class="left line_right"
              @click="$router.push('/refund/manageList?status=-2&refundType=&isCenterReceipt=&cover=2')"
            >
              <p class="status">待受理(起)</p>
              <div class="num">{{homeInfo.waitAccept}}</div>
            </div>
            <div
              class="left"
              @click="$router.push('/refund/manageList?status=-3&refundType=&isCenterReceipt=&cover=2')"
            >
              <p class="status">待处理(起)</p>
              <div class="num">{{homeInfo.waitHandle}}</div>
            </div>
          </div>
        </div>
        <div class="item">
          <p class="t_text">退货单查询</p>
          <div class="box">
            <div
              class="left line_right line_bottom"
              @click="$router.push('/refund/manageList?status=&refundType=&isCenterReceipt=&cover=1')"
            >
              <p class="status">全部退货列表(起)</p>
              <div class="num">{{homeInfo.allReturnList}}</div>
            </div>
            <div
              class="left line_bottom"
              @click="$router.push('/refund/manageList?status=-14&refundType=&isCenterReceipt=&cover=1')"
            >
              <p class="status">不予退货列表(起)</p>
              <div class="num">{{homeInfo.refuseAccept}}</div>
            </div>
            <div
              class="left line_right"
              @click="$router.push('/refund/manageList?status=&refundType=20&isCenterReceipt=&cover=1')"
            >
              <p class="status">企业退货列表(起)</p>
              <div class="num">{{homeInfo.enterpriseReturnList}}</div>
            </div>
            <div
              class="left"
              @click="$router.push('/refund/manageList?status=&refundType=10&isCenterReceipt=&cover=1')"
            >
              <p class="status">垫付列表(起)</p>
              <div class="num">{{homeInfo.advancesList}}</div>
            </div>
          </div>
        </div>
        <div class="item">
          <p class="t_text">垫付金管理</p>
          <div class="box">
            <div
              class="left line_right"
              @click="$router.push('/refund/manageList?status=&refundType=10&isCenterReceipt=0&cover=2')"
            >
              <p class="status">垫付未还列表(起)</p>
              <div class="num">{{homeInfo.advancesRecoveredList}}</div>
            </div>
            <div
              class="left"
              @click="$router.push('/refund/manageList?status=&refundType=10&isCenterReceipt=1&cover=2')"
            >
              <p class="status">垫付已还列表(起)</p>
              <div class="num">{{homeInfo.alreadyRecoveredList}}</div>
            </div>
          </div>
        </div>
        <div class="item">
          <p class="t_text">垫付金统计</p>
          <div class="price">
            <div class="p_item">
              <p class="about_statu fontColor">垫付金总额</p>
              <p
                class="money"
                v-if="homeInfo.advanceTotalAmount"
              >¥{{homeInfo.advanceTotalAmount|formarterMoneyFixedTwo}}</p>
            </div>
            <div class="p_item">
              <p class="about_statu">垫付金未还</p>
              <p
                class="money"
                style="color:#F75C32;"
                v-if="homeInfo.notAdvanceAmount"
              >¥{{homeInfo.notAdvanceAmount|formarterMoneyFixedTwo}}</p>
            </div>
            <div class="p_item">
              <p class="about_statu">使用占比</p>
              <p class="money" style="color:#FFA509;">{{radio}}%</p>
            </div>
          </div>
          <div class="total">近30天退货金统计</div>
          <div class="footer_one">
            <div class="total_view line_bottom">
              <div class="line"></div>
              <div class="total_view_top">
                <div class="total_view_top_left line_right">
                  <p class="total_view_top_left_p1">退货申请总额</p>
                  <p class="total_view_top_left_p2" v-if="baseInfo.returnAppleAmount">
                    {{baseInfo.returnAppleAmount|formarterMoney}}
                    <span class="RMB">元</span>
                  </p>
                </div>
                <div class="total_view_top_left">
                  <p class="total_view_top_left_p1">退货成功金额</p>
                  <p class="total_view_top_left_p2" v-if="baseInfo.returnAppleAmount">
                    {{baseInfo.returnSuccessAmount|formarterMoney}}
                    <span class="RMB">元</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="line_contain line_bottom">
              <pieCharts :pieData="pieList" :pieRatio="pieRatio" ref="pieChart" />
            </div>
            <div class="lin_bottom">
              <div class="lin_bottom_one">
                <div class="lin_bottom_one_left">监理中心垫付金额</div>
                <div class="lin_bottom_one_right">{{baseInfo.advancesAmount}}元</div>
              </div>
              <div class="lin_bottom_one">
                <div class="lin_bottom_one_left">企业退货金额</div>
                <div class="lin_bottom_one_right">{{baseInfo.enterpriseReturnAmount}}元</div>
              </div>
            </div>
          </div>
          <div class="day_info">近30天退货同比趋势</div>
          <div class="line-contain">
            <lineChartsTwo
              :data="lineList"
              v-if="lineList.length"
              :dataTitle="lineListTitle"
              :color="color"
              :showYear="true"
              unit="起"
            />
            <!-- <lineCharts :data="lineList" :color="color" :showYear="true" unit="起"/> -->
          </div>
          <div class="day_info">退货商品类型分布情况</div>
          <div class="line-contain line-contain-top">
            <medicinePieCharts
              :pieData="medicinePieList"
              :color="colorList"
              :ShowText="isShowText"
            />
          </div>
        </div>
      </div>
    </div>
    <load-view v-if="LOADING"></load-view>
  </div>
</template>

<script>
import pieCharts from "../../../../components/PieCharts";
import lineCharts from "../../../../components/LineCharts";
import util from "../../../../utils/common";
import api from "../../../../service/modules/refund";
import loadView from "../../../../components/loadingView";
import lineChartsTwo from "@/components/LineChartsTwo";
import medicinePieCharts from "@/components/MedicinePieCharts";

export default {
  components: {
    // betterScroll,
    pieCharts,
    lineCharts,
    "load-view": loadView,
    lineChartsTwo,
    medicinePieCharts
  },

  data() {
    return {
      LOADING: this.$store.state.refund.LOADING,
      // isshowBox:false,
      val: 1212,
      title: "退货首页",
      info: "",
      homeInfo: "",
      baseInfo: "",
      pecent: "6",
      chart: null,
      chartList: [],
      waitHandle: 0,
      handling: 0,
      isshow: true,
      lineChart: null,
      // 折线图
      lineList: [],
      lineListTitle: [],
      color: "green",
      // 饼图
      pieList: [
        { value: 40, name: "退货申请总额" },
        { value: 10, name: "退货成功金额" }
      ],
      shapeDate: [
        {
          x: "1",
          y: "0"
        }
      ],
      radio: 0,
      pieRatio: "0",
      medicinePieList: [],
      colorList: ["#A0A7E5", "#69E5C1", "#626B90", "#C3EAAD", "#40B0E2"],
      isShowText: true
    };
  },
  mounted() {
    this.getNoticeNum();
  },
  created() {
    this.getUser();
    this.getWorkbenchPrice();
  },
  methods: {
    /**
     *    退货商品类型分布情况
     */
    getShoppingType() {
      api.classified().then(res => {
        if (res.ret === 0) {
          this.medicinePieList = res.data.map(item => {
            return {
              name: item.productTypeText,
              type: item.type,
              count: item.count,
              productType: item.productType,
              value: item.value
            };
          });
        }
      });
    },
    // 拉取待办数量
    getNoticeNum() {
      this.$store.dispatch("notice/getRefundNum");
    },
    getAllCity(citycode) {
      // 获取所有的市
      api.getCity({ regionCode: citycode }).then(res => {
        var list = res.data[0];
        let city = [];
        if (list.regionType === 1) {
          // 多个市
          if (list.children != null) {
            this.cols = 2;
            var obj = {
              value: list.code,
              label: list.name,
              children: [{ value: "530000", label: "全部", children: [] }]
            };
            list.children.map((item, index) => {
              obj.children.push({
                value: item.code,
                label: item.name,
                children: []
              });
            });
            city.push(obj);
          } else {
            city.push({ value: list.code, label: list.name, children: [] });
            this.cols = 1;
          }
        } else {
          // 一个市
          if (list.children != null) {
            this.cols = 2;
            var obj = {
              value: list.code,
              label: list.name,
              children: [{ value: list.code, label: "全部", children: [] }]
            };
            list.children.map((item, index) => {
              obj.children.push({
                value: item.code,
                label: item.name,
                children: []
              });
            });
            city.push(obj);
          } else {
            city.push({ value: list.code, label: list.name, children: [] });
            this.cols = 1;
          }
        }
        this.typeList = [];
        this.typeList.push(city);
        setTimeout(() => {
          this.$refs.commonPicker._initFresh();
        }, 50);
      });
    },
    getUser() {
      // 获取用户信息

      api.currentUser().then(res => {
        if (res.ret === 0) {
          this.info = res.data;
          this.$store.commit("refund/getUserInfo", res.data);
          this.getType();
          this.getInfoList();
          this.getLate();
          this.getShoppingType();
        } else {
        }
      });
    },
    getInfoList() {
      api.workbench({}).then(res => {
        if (res.ret === 0) {
          this.homeInfo = res.data;
          this.waitHANDle = res.data.waitHandle;
          this.handling = res.data.handling;
          //   this.radio=(Number(res.data.notAdvanceAmount)/Number(res.data.advanceTotalAmount)*100).toFixed(2);
          //   this.radio=Number(res.data.notAdvanceAmount)/Number(res.data.advanceTotalAmount)*100;
          if (res.data.notAdvanceAmount === 0) {
            this.radio = 0;
          } else {
            this.radio =
              res.data.advanceTotalAmount > 0
                ? (Number(res.data.notAdvanceAmount) /
                    Number(res.data.advanceTotalAmount)) *
                  100
                : 0;
          }
          let countFloat = String(this.radio).indexOf(".") + 1; // 获取小数点的位置
          if (countFloat > 0) {
            // 是小数
            this.radio = this.radio.toFixed(2);
          } else {
            // 不是小数
          }
        }
      });
    },
    getWorkbenchPrice() {
      // 圆环的统计数据
      api.workbenchPrice().then(res => {
        if (res.ret === 0) {
          this.baseInfo = res.data;
          this.baseInfo.returnAppleAmount =
            this.baseInfo.returnAppleAmount.replace(/,/g, "") - 0;
          this.baseInfo.returnSuccessAmount =
            this.baseInfo.returnSuccessAmount.replace(/,/g, "") - 0;
          this.pieList = [
            // { value: this.baseInfo.returnSuccessAmount, name: '退货成功金额' },
            // { value: this.baseInfo.returnAppleAmount, name: '退货申请总额' }

            {
              value:
                this.baseInfo.returnAppleAmount -
                this.baseInfo.returnSuccessAmount,
              name: "退货申请总额"
            },
            { value: this.baseInfo.returnSuccessAmount, name: "退货成功金额" }
          ];
          try {
            // this.pieRatio = res.data.ratio;
            this.pieRatio = (
              (Number(this.baseInfo.returnSuccessAmount) /
                Number(this.baseInfo.returnAppleAmount)) *
              100
            ).toFixed(2);
            // this.pieRatio = '50'
            // this.pieRatio = (((Number(this.baseInfo.returnAppleAmount)-Number(this.baseInfo.returnSuccessAmount)) / Number(this.baseInfo.returnAppleAmount) * 100)).toFixed(2);
            console.log(this.pieRatio);
            if (this.pieRatio === "NaN") {
              this.pieRatio = "0";
            }
          } catch (error) {}

          // 退货金额统计
          // this.$refs.pieChart.setOptions(this.pieList)
        }
      });
    },
    getType() {
      // 获取配置中心数据
      api.typePicker({}).then(res => {
        if (res.ret === 0) {
          // this.$store.state.configlist = res.data;
          util.setJsonLocal("configList", res.data);
        }
      });
    },
    getLate() {
      // 近30天退货趋势数据
      // api.lately30({ now: new Date().getTime(), days: '-30' }).then(res => {
      //     if (res.ret === 0) {
      //         this.lineList = [];
      //         res.data.map(item => {
      //             let obj = { xAxis: item.date.substring(5, 10), num: item.count }
      //             this.lineList.push(obj);
      //         })
      //     }
      // });
      api
        .visualTrend({
          dateType: 4,
          cover: 1,
          startDate: util.startdateDay().startdate,
          endDate: util.startdateDay().enddate
        })
        .then(res => {
          if (res.ret === 0) {
            this.lineList = [];
            let dataOne = [];
            let dataTwo = [];
            let data = res.data.reverse();
            for (let i = 0; i < data.length; i++) {
              if (i % 2 == 0) {
                dataOne.push(data[i].applyNumValue);
                this.lineListTitle.push(data[i].date.substring(5, 10));
              } else {
                dataTwo.push(data[i].applyNumValue);
              }
            }
            this.lineList = [
              {
                name: "申请数量",
                type: "line",
                stack: "总量",
                data: dataOne
                // data: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]
              },
              {
                name: "申请数量",
                type: "line",
                stack: "总量",
                data: dataTwo
                // data: [9,8,7,6,5,4,3,2,1,0,9,8,7,6,5,4,3,2,1,0,9,8,7,6,5,4,3,2,1,9,8]
              }
            ];
          }
        });
    }
  },
  filters: {
    filt2(value) {
      if (!value) return "0.00";
      var intPart = Number(value).toFixed(0); // 整数部分
      var intPartFormat = intPart
        .toString()
        .replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
      var floatPart = ".00"; // 预定义小数部分
      var value2Array = value.toString().split(".");
      if (value2Array.length === 2) {
        // 有小数部分
        floatPart = value2Array[1].toString(); // 拿到小数部分
        if (floatPart.length === 1) {
          // 补0,实际上用不着
          return intPartFormat + "." + floatPart + "0";
        } else {
          return intPartFormat + "." + floatPart;
        }
      } else {
        // 没有小数部分，补0;
        return intPartFormat;
      }
    },
    formarterMoney(val) {
      return val.toLocaleString();
    },
    formarterMoneyFixedTwo(val) {
      // let money = Number(val.toFixed(2)).toLocaleString()
      // return money;
      return (+val || 0)
        .toFixed(2)
        .toString()
        .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
    }
  },
  beforeDestroy() {
    if (this.chart || this.lineChart) {
      this.chart = null;
      this.lineChart = null;
    }
  }
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  overflow: hidden;
  background-color: #fafafa;
  .container {
    width: 100%;
    padding-bottom: 20px;
    .title {
      width: 100%;
      height: 84px;
      background-color: @base-color;
      position: relative;
      display: flex;
      .images {
        height: 64px;
        width: 68px;
        margin-top: 12px;
        margin-right: 16px;
        img {
          display: inline-block;
          width: 56px;
          height: 64px;
        }
      }
      .title_text {
        width: 100%;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 12px;
        color: #ccc;
      }
      .title_info {
        width: 100%;
        padding: 10px 0 0 20px;
        box-sizing: border-box;
        .title_logo {
          position: absolute;
          right: 4px;
          bottom: 0px;
          width: 95px;
          height: 106px;
        }
        .name {
          margin-top: 14px;
          span:nth-child(1) {
            display: inline-block;
            vertical-align: middle;
            font-size: 12px;
            color: #ffffff;
          }
        }
        .tip2 {
          font-size: 12px;
          color: #ffffff;
          margin-top: 12px;
          .tip2_line {
            content: "";
            margin: -8px 5px;
            background: #ebedf0;
            width: 1px;
            height: 16px;
            -webkit-transform: scaleY(0.5);
            transform: scale(0.5);
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            margin-top: 0px;
            display: inline-block;
          }
        }
      }
    }
    .check_list {
      width: 100%;
      padding: 0 12px;
      box-sizing: border-box;
      .item {
        width: 100%;
        .t_text {
          margin-top: 12px;
          font-size: 20px;
          color: #333;
          line-height: 44px;
          font-size: 20px;
          font-weight: bold;
        }
        .box {
          width: 100%;
          box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
          font-size: 0;
          background: #ffffff;
          .left {
            width: 50%;
            height: 100px;
            display: inline-block;
            text-align: center;
            .num {
              margin-top: 8px;
              font-size: 32px;
              color: @base-color;
              display: inline-block;
              vertical-align: bottom;
              font-weight: 700;
              font-family: PingFangSC-Regular, PingFang SC;
              -webkit-font-smoothing: antialiased;
            }
            .status {
              font-size: 12px;
              margin-top: 24px;
              color: #333333;
            }
          }
        }
        .price {
          background-color: #ffffff;
          display: flex;
          display: -webkit-flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 24px 0 0 16px;
          box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
          .p_item {
            .money {
              font-size: 24px;
              font-weight: 700;
              color: #36b374;
              margin-bottom: 20px;
              font-family: PingFangSC-Regular, PingFang SC;
              -webkit-font-smoothing: antialiased;
            }
            .about_statu {
              font-size: 12px;
              color: #333;
              margin-bottom: 10px;
            }
          }
        }
        .total {
          font-size: 20px;
          color: #2a2a2a;
          line-height: 44px;
          margin-top: 12px;
          font-weight: bold;
        }
        .footer_one {
          box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
          border-radius: 3px;
          overflow: hidden;
        }
        .total_view {
          background-color: #ffffff;
          // border-bottom: 1px solid #eeeeee;
          position: relative;
          .line {
            position: absolute;
            height: 100%;
            width: 1px;
            // background-color: #eeeeee;
            left: 50%;
            top: 0;
          }
          .total_view_top {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            .total_view_top_left {
              padding: 12px 0;
              box-sizing: border-box;
              text-align: center;
              width: 50%;
              .total_view_top_left_p1 {
                line-height: 20px;
                font-size: 12px;
                color: #333333;
              }
              .total_view_top_left_p2 {
                font-size: 20px;
                line-height: 28px;
                font-weight: 700;
                color: #36b374;
                font-family: PingFangSC-Regular, PingFang SC;
                -webkit-font-smoothing: antialiased;
              }
              .RMB {
                font-size: 12px;
              }
            }
          }
        }
        .lin_bottom {
          // border-top: 1px solid #eeeeee;
          overflow: hidden;
          padding: 18px 12px;

          background-color: #ffffff;
          .lin_bottom_one {
            font-size: 12px;
            line-height: 24px;
            overflow: hidden;
            .lin_bottom_one_left {
              float: left;
            }
            .lin_bottom_one_right {
              float: right;
            }
          }
        }
        .day_info {
          font-size: 20px;
          color: #2a2a2a;
          margin-top: 12px;
          line-height: 44px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
<style>
.line_contain {
  height: 190px;
  padding-bottom: 21px;
  background-color: #ffffff;
}
.line-contain {
  /* height: 234px; */
  height: 250px;
  background-color: #ffffff;
  border-radius: 3px;
  box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
}
.line-contain-top {
  padding-top: 16px;
}
.home_price {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -70%);
  font-size: 20px;
  color: #1890ff;
}
.chart-wrapper {
  text-align: center;
  position: relative;
}
.chart-wrapper1 {
  text-align: center;
}
</style>
